import React from 'react'
import { UIBadge, type UIBadgeProps } from './ui-badge'

export interface UIBadgeSecondaryProps extends Omit<UIBadgeProps, 'variant' | 'children'> {
  children?: React.ReactNode
}

/**
 * UIBadgeSecondary - Secondary Badge Block
 * 보조 스타일의 배지 컴포넌트입니다.
 * 보조적인 스타일의 배지입니다.
 */
export const UIBadgeSecondary = React.forwardRef<HTMLSpanElement, UIBadgeSecondaryProps>(
  ({ children = "Secondary", ...props }, ref) => {
    return (
      <UIBadge
        ref={ref}
        variant="secondary"
        {...props}
      >
        {children}
      </UIBadge>
    )
  }
)

UIBadgeSecondary.displayName = "UIBadgeSecondary"